import React from 'react';
import PropTypes from 'prop-types';

import { injectStyles } from 'injectStyles';
import styles from './PlayerBottom.styles';
import PlayerNowPlaying from './PlayerNowPlaying';
import PlayerControls from './PlayerControls';
import PlayerButtons from './PlayerButtons';
import PlayerUnavailable from './PlayerUnavailable';
import { isTouch } from 'util/device';
import { isEmpty } from 'util/index';

const PlayerBottom = ({ classes, isComponentLoading, isOnline, playerError, error, hasContent, browser }) => {
  const getPlayerButtons = () => {
    if (isTouch && browser.down.sm) {
      return null;
    } else {
      return <PlayerButtons />;
    }
  };

  const hasError = !isEmpty(playerError) || error;

  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <PlayerUnavailable isOnline={isOnline} hasError={hasError} hasContent={hasContent} />
        {isOnline && !hasError && (
          <>
            {hasContent && <PlayerNowPlaying />}
            <PlayerControls isComponentLoading={isComponentLoading} />
            {getPlayerButtons()}
          </>
        )}
      </div>
    </div>
  );
};

PlayerBottom.propTypes = {
  classes: PropTypes.object.isRequired,
  isComponentLoading: PropTypes.bool,
  isOnline: PropTypes.bool,
  error: PropTypes.bool,
  playerError: PropTypes.object,
  hasContent: PropTypes.bool,
  browser: PropTypes.object.isRequired,
};

PlayerBottom.defaultProps = {
  isComponentLoading: false,
  isOnline: true,
  error: false,
  playerError: null,
  hasContent: true,
};

export default injectStyles(styles)(PlayerBottom);
